module.exports = __webpack_public_path__ + "static/media/wizualizacja-93.ae96de11.png";